export function countRows(arr) {
  try {
    let count = "";
    if (arr.length > 0) {
      count = arr.length;
    }
    return count;
  } catch (error) {
    console.error("Error in countRows function:", error);
    return "";
  }
}
